export default class Footer {
  constructor() {
    this.privacySettingsButton = document.querySelector(".privacy-settings")

    if (this.privacySettingsButton) {
      this.privacySettingsButton.addEventListener("click", () => {
        const cookieBanner = document.querySelector("cookie-banner")
        if (cookieBanner) {
          cookieBanner.promptForConsent()
        }
      })
    }
  }
}
